export default __webpack_public_path__ + "static/media/Vector.e2ae6513.svg";